import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="termsconditions-container">
      <h1>Terms & Conditions</h1>
      <p>By using our website, you agree to our terms and conditions. Please read them carefully to understand your rights and obligations.</p>
      <p><strong>Disclaimer:</strong> Shop Scout is an independent platform and is not affiliated with, endorsed by, or in partnership with any brands featured on this website. All brand names, logos, and product images are the property of their respective owners and are used for identification purposes only.</p>
    </div>
  );
};

export default TermsConditions;
